module.exports = __webpack_public_path__ + "static/media/Asset_logo_2.ee875244.svg";